/*
    Imports the Roast API URL from the config.
*/
import { OG_CONFIG } from '@/services/api/config.js';
import axios from 'axios';

export default {
  login: function(data) {
    return axios.post(OG_CONFIG.BASE_URL + '/oauth/token', {
      grant_type: 'password',
      client_id: OG_CONFIG.CLIENT_ID,
      client_secret: OG_CONFIG.CLIENT_SECRET,
      username: data.username,
      password: data.password,
    });
  },
  googleLoginUrl: function() {
    return `${OG_CONFIG.BASE_URL}/social/redirect/google`;
  },
  resetPassword: function(data) {
    return axios.post(OG_CONFIG.BASE_URL + '/api/v1/password/create', data);
  },
  checkTokenResetPassword: function(data) {
    return axios.get(OG_CONFIG.BASE_URL + '/api/v1/password/find/' + data);
  },
  resetNewPassword: function(data) {
    return axios.post(OG_CONFIG.BASE_URL + '/api/v1/password/reset', data);
  },
};
